import React from "react";

const Java_Area_Rectangle = () => {
  return (
    <div>
      <h1>Java Area Rectangle</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Area Rectangle in Java.</p>
    </div>
  );
};

export default Java_Area_Rectangle;
